import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  GcButtonComponent,
  GcTagComponent,
  GcTextComponent,
  GcTooltipComponent,
  IpoButtonComponent,
  IpoFilterByPropertiesPipe,
  IpoFlexibleTableModule,
  IpoInputComponent,
  IpoLanguageService,
  IpoLoadingSpinnerComponent,
  IpoSkeletonComponent,
  IpoStringService,
  IpoTabComponent,
  IpoTabsComponent,
  IpoTagComponent,
  IpoTranslateArrayPipe,
  IpoTranslatePipe,
  stringServiceFactory,
} from '@ip-only/front-end-library';
import { GcHeaderComponent } from '../shared/gc-header/gc-header.component';
import { SharedModule } from '../shared/shared.module';
import { DeliveryOverviewAppRouterModule } from './delivery-overview-app-routing.module';
import { DeliveryOverviewSearchComponent } from './delivery-overview-wrapper/delivery-overview-search/delivery-overview-search.component';
import { DeliveryOverviewTableComponent } from './delivery-overview-wrapper/delivery-overview-table/delivery-overview-table.component';
import { DeliveryOverviewWrapperComponent } from './delivery-overview-wrapper/delivery-overview-wrapper.component';
import { ProjectCompletionModalComponent } from './delivery-overview-wrapper/project-completion-modal/project-completion-modal.component';
import { ProjectsOverviewInterceptor } from './service/api/projects-overview.interceptor';
import { default as en, default as fi } from './strings.en';
import sv from './strings.sv';

@NgModule({
  declarations: [
    DeliveryOverviewWrapperComponent,
    DeliveryOverviewTableComponent,
    DeliveryOverviewSearchComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DeliveryOverviewAppRouterModule,
    IpoTabsComponent,
    IpoTabComponent,
    IpoTranslatePipe,
    IpoTranslateArrayPipe,
    IpoFlexibleTableModule,
    IpoTagComponent,
    IpoInputComponent,
    IpoFilterByPropertiesPipe,
    IpoLoadingSpinnerComponent,
    IpoSkeletonComponent,
    IpoButtonComponent,
    GcTextComponent,
    GcButtonComponent,
    ProjectCompletionModalComponent,
    GcTagComponent,
    GcTooltipComponent,
    GcHeaderComponent,
  ],
  providers: [
    {
      provide: IpoStringService,
      useFactory: stringServiceFactory({ en, sv, fi }),
      deps: [IpoLanguageService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProjectsOverviewInterceptor,
      multi: true,
    },
  ],
})
export class DeliveryOverviewAppModule {}
